
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checklist from 'vux/src/components/checklist/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: 'curtainMapOrder',
directives: {
TransferDom
},
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group,Datetime,TransferDom,Checklist,XButton,PopupHeader,Popup
},

data () {
return {
phone:'',
datetimeStatus:false,
pickerWorkerStatus:false,
startDate:'',
dateStr:'',
dateValue:'',
isActive:0,
map:null,
markerLayer:null,
infoWindow:null,
mapReady:false,
list:[],
workerId:[],
grade:0,
itemId:0,
justOpened:false,
statusArr:[
{
key:0,
value:'全部',
},
{
key:1,
value:'待分配',
},
{
key:2,
value:'待分配',
},
{
key:3,
value:'待上门'
},
{
key:4,
value:'拆卸中'
},
{
key:5,
value:'待安装'
},
],
worker:[],
}
},
created(){
this.grade = parseInt(this.$func.getLocal('grade'));
if(this.grade == 23){
this.statusArr = [
{
key:0,
value:'全部',
},
{
key:2,
value:'待分配',
},
{
key:3,
value:'待上门'
},
{
key:4,
value:'拆卸中'
},
{
key:5,
value:'待安装'
},
];
this.getWorker();
}else if(this.grade == 24){
this.statusArr = [
{
key:0,
value:'全部',
},
{
key:2,
value:'待抢单',
},
{
key:3,
value:'待上门'
},
{
key:4,
value:'拆卸中'
},
{
key:5,
value:'待安装'
},
];
}
this.isActive = Number(this.$route.params.status) || 0;
let dateStr = this.$route.params.dateStr || '';
switch(dateStr){
case '':
this.dateValue = '全部';
break;
case 'wait':
this.dateValue = '未设置';
break;
default:
this.dateValue = dateStr;
break;
}
this.dateStr = dateStr;
this.getList();
},
mounted(){
this.loadQQMap().then(()=>{
this.initMap();
this.mapReady = true;
this.renderMarkers();
});
},
methods:{
datetimeChange(val){
this.dateStr = val;
this.dateValue = val;
this.datetimeStatus = false;
this.getList();
},
selectStatus(val){
this.isActive = val;
this.getList();
},
assignWorker(id){
this.itemId = id;
this.workerId = [];
this.pickerWorkerStatus = true;
},
onWorkerChange (value) {
this.workerId = value;
},
changeStatus(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}




if(!this.workerId.length){
this.$func.showToast('请选择拆装师傅');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.changeCurtainStatus({id:this.itemId,status:3,workerId:this.workerId.join(',')}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.pickerWorkerStatus = false;
this.list = [];
this.getList();
}, 300);
}
});
})
},
grabOrder(id){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm('确认抢单？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainGrabOrder({id:id}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.list = [];
this.getList();
}, 300);
}
});
})
},
getList(){
this.$api.getCurtainMapOrder({phone:this.phone,status:this.isActive,home_date:this.dateStr}).then((res)=>{
if(res){
this.list = Array.isArray(res.data) ? res.data : [];
this.renderMarkers();
}
})
},
getWorker() {
this.$api.getCurtainWorker({}).then((res)=>{
if(res){
this.worker = res.data;
}
})
},
loadQQMap(){
return new Promise((resolve,reject)=>{
if(window.TMap){
resolve();
return;
}
const s = document.createElement('script');
s.src = 'https://map.qq.com/api/gljs?v=1.exp&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM';
s.onload = ()=>resolve();
s.onerror = (e)=>reject(e);
document.head.appendChild(s);
})
},
initMap(){
let center;






center = new TMap.LatLng(34.26993,108.94716);

const el = document.getElementById('cm-map');
if(el){
el.style.position = 'absolute';
el.style.left = '0px';
el.style.top = '0px';
el.style.overflow = 'hidden';
el.style.zIndex = '10';
el.style.width = '100%';
el.style.height = '100%';
}
this.map = new TMap.Map(el,{center:center,zoom:12});
if(el){
el.style.zIndex = '10';
}
this.infoWindow = new TMap.InfoWindow({position:center,content:'',offset:{x:0,y:-30}});
this.map.on('click',(evt)=>{
if(this.pickerWorkerStatus){

return;
}
if(this.infoWindow){
if(!this.justOpened){
this.infoWindow.close();
}
}
})
},
clearMarkers(){
if(this.markerLayer){
this.markerLayer.setMap(null);
this.markerLayer = null;
}
if(this.infoWindow){
this.infoWindow.close();
}
},
fitBounds(){
if(!this.map) return;
const items = Array.isArray(this.list) ? this.list.filter(it=>it && it.lat && it.lng) : [];
if(!items.length) return;
const bounds = new TMap.LatLngBounds();
items.forEach(item=>{
bounds.extend(new TMap.LatLng(Number(item.lat),Number(item.lng)));
})
this.map.fitBounds(bounds,{padding:20});
},
renderMarkers(){
if(!this.map) return;
this.clearMarkers();
const items = Array.isArray(this.list) ? this.list.filter(it=>it && it.lat && it.lng) : [];
const geometries = items.map((item,idx)=>{
return {
id:String(item.id || idx),
styleId:'marker',
position:new TMap.LatLng(Number(item.lat),Number(item.lng)),
properties:{
name:item.name||'',
phone:item.phone||'',
province:item.province||'',
city:item.city||'',
district:item.district||'',
address:item.address||'',
goods_title:item.goods_title||'',
home_time:item.home_time||'',
status: typeof item.status === 'number' ? item.status : Number(item.status) || 0
}
}
})
this.markerLayer = new TMap.MultiMarker({
map:this.map,
styles:{
marker:new TMap.MarkerStyle({})
},
geometries:geometries
})
this.markerLayer.on('click',(evt)=>{
const g = evt.geometry;
const p = g.position;
const canAssign = this.grade == 23 && Number(g.properties.status) === 2;
const canGrab = this.grade == 24 && Number(g.properties.status) === 2;
const actions = canAssign
? `<span id="btnAssign-${g.id}" style="background:#FE5649;color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;cursor:pointer;">分配师傅</span>`
: (canGrab
? `<span id="btnGrab-${g.id}" style="background:#1AAD19;color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;cursor:pointer;">抢单</span>`
: '');
const content = `
<div style="font-size:12px;line-height:1.6;word-break:break-all;white-space:normal;text-align:left">
<div>${g.properties.name} ${g.properties.phone}</div>
<div>上门时间：${g.properties.home_time}</div>
<div>服务项目：${g.properties.goods_title}</div>
<div>${g.properties.province}${g.properties.city}${g.properties.district}</div>
<div>${g.properties.address}</div>
<div style="display:flex;justify-content:flex-end;margin-top:5px;">${actions}</div>
</div>
`;
this.justOpened = true;
this.infoWindow.setMap(this.map);
this.infoWindow.setPosition(p);
if(typeof this.infoWindow.setOffset === 'function'){
this.infoWindow.setOffset({x:0,y:-30});
}else{
const p2 = new TMap.LatLng(p.lat + 0.0006, p.lng);
this.infoWindow.setPosition(p2);
}
this.infoWindow.setContent(content);
this.infoWindow.open();
this.map.setCenter(p);
setTimeout(()=>{ this.justOpened = false; }, 200);
setTimeout(()=>{
if(canAssign){
const btnAssign = document.getElementById(`btnAssign-${g.id}`);
if(btnAssign){
btnAssign.addEventListener('click',()=>this.assignWorker(g.id));
}
}else if(canGrab){
const btnGrab = document.getElementById(`btnGrab-${g.id}`);
if(btnGrab){
btnGrab.addEventListener('click',()=>this.grabOrder(g.id));
}
}
},0)
})
if(items.length){
this.fitBounds();
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/curtainMapOrder.vue